import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErroInfo } from '@gestor-web/@core/api/ords/model';
import { OperadorasSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GeralService } from './geral.service';
import { LoaderService } from './loader.service';

export const HEADER_SKIP_LOAD_INTERCEPTOR = 'X-Skip-Load-Interceptor';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private operadora: string;

  constructor(
    private loaderService: LoaderService,
    private geralService: GeralService,
    private router: Router,
    private store: Store,
  ) {
    this.store.select(OperadorasSelectors.selectWorkspaceOperadora).subscribe(operadora => {
      this.operadora = operadora?.cd_registro_ans;
    });
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('[Loader] intercept', req.url);

    if (req.headers.has(HEADER_SKIP_LOAD_INTERCEPTOR)) {
      // console.log('[Loader] skip intercept');
      const headers = req.headers.delete(HEADER_SKIP_LOAD_INTERCEPTOR);
      return next.handle(req.clone({ headers }));
    }

    this.requests.push(req);

    this.loaderService.isLoading(true);
    return new Observable(observer => {
      const subscription = next
        .handle(req)
        .pipe(takeUntil(this.loaderService.cancelPendingRequests$))
        .subscribe({
          next: event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          error: err => {
            // Register error only when authenticated
            if (err.status != 401) {
              this.geralService.registrarErro({
                cd_registro_ans: this.operadora,
                ds_url_api: req.urlWithParams,
                ds_url_aplicacao: this.router.routerState.snapshot.url,
                ds_erro: this.extractErrorInfo(err, req),
              });
            }
            this.removeRequest(req);
            observer.error(err);
          },
          complete: () => {
            this.removeRequest(req);
            observer.complete();
          },
        });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  extractErrorInfo(err: any, req: HttpRequest<any>): string {
    const info: ErroInfo = {};

    let nomeArquivo: string | null = null;

    if (req.body) {
      // erro vindo da pré-verificação (JSON)
      if (req.body.nm_arquivo) {
        nomeArquivo = req.body.nm_arquivo;
      }

      // erro vindo do upload (FormData)
      if (req.body instanceof FormData && req.body.has('nm_arquivo')) {
        nomeArquivo = req.body.get('nm_arquivo') as string;
      }
    }

    if (err.name) {
      info.name = err.name;
    }
    if (err.message) {
      info.message = err.message;
    }
    if (err.error && typeof err.error === 'object') {
      info.error = err.error as any;

      if (nomeArquivo) {
        (info.error as any).nome_arquivo_a_postar = nomeArquivo;
      }
    }
    if (err.status) {
      info.status = err.status;
    }
    return JSON.stringify(info);
  }
}
